import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUploadCloud02 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 18,
	viewBox: "0 0 19 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.16675 12.3333L9.50008 9M9.50008 9L12.8334 12.3333M9.50008 9V16.5M16.1667 12.9524C17.1847 12.1117 17.8334 10.8399 17.8334 9.41667C17.8334 6.88536 15.7814 4.83333 13.2501 4.83333C13.068 4.83333 12.8976 4.73833 12.8052 4.58145C11.7185 2.73736 9.71211 1.5 7.41675 1.5C3.96497 1.5 1.16675 4.29822 1.16675 7.75C1.16675 9.47175 1.86295 11.0309 2.98921 12.1613",
		stroke: "#475569",
		strokeWidth: 1.66667,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgUploadCloud02;
